import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from "@angular/router";
import {AuthGuard} from "../app-auth/guards/auth.guard";
import {LoginGeneralComponent} from "../app-auth/login/login-general/login-general.component";
import {EnvInitializer} from "../common/services/environement.initializer";
import {LoginInitializer} from "../common/services/login.initializer";
import {LicenseGuard} from "./license/license.guard";
import {LicenseNotFoundComponent} from "./license/license.no.found/license.not.found.component";

const defaultRoute = 'selfscheduling';

const routes: Routes = [{
  path: '',
  pathMatch: 'full',
  redirectTo: defaultRoute
  },
  {
    path: 'login',
    component: LoginGeneralComponent,
    canActivate: [LicenseGuard],
    resolve: {
      initData: LoginInitializer
    }
  },
  {
		path: 'selfscheduling',
		loadChildren: () => import("../app-main/self.scheduling/self.scheduling.module").then(mod => mod.SelfSchedulingModule),
		canActivate: [AuthGuard],
    resolve: {
      initData: EnvInitializer
    }
	},
  {
    path: 'licensenotfound',
    component: LicenseNotFoundComponent
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  providers: [EnvInitializer, LoginInitializer]
})
export class AppRoutingModule { }
